import {Permissions} from "../types/User";

export type NavRequire = "manage_users" | "logged_in" | "see_premium" | "full_access";

export type MainNavItem = {
    id: string;
    label: string;
    to?: string;
    kind?: "route" | "profile" | "subscribe";
    require?: NavRequire;
};

export const MAIN_NAV_ITEMS: MainNavItem[] = [
    {id: "home", label: "Home", to: "/", kind: "route"},
    {id: "listings", label: "Listings", to: "/listings", kind: "route"},
    {id: "add-listing", label: "Add Listing", to: "/prop/new", kind: "route"},
    {id: "profile", label: "Profile", to: "/profile", kind: "profile"},
    {id: "users", label: "Users", to: "/users", kind: "route", require: "manage_users"},
    {id: "phone-accounts", label: "Phone-Accounts", to: "/quick-logins", kind: "route", require: "manage_users"},
    {id: "support", label: "Support Tickets", to: "/support", kind: "route", require: "logged_in"},
    {id: "subscription", label: "Daily Subscription", kind: "subscribe", require: "see_premium"},
    {id: "scheduler", label: "Scheduler", to: "/scheduler", kind: "route", require: "full_access"},
];

export function isNavItemVisible(
    item: MainNavItem,
    ctx: { jwt?: string; can: (...permission: (keyof Permissions)[]) => boolean }
): boolean {
    switch (item.require) {
        case "manage_users":
            return ctx.can("manage_users");
        case "logged_in":
            return !!ctx.jwt;
        case "see_premium":
            return ctx.can("see_premium");
        case "full_access":
            return ctx.can("full_access");
        default:
            return true;
    }
}
